import './newsletter.scss';

import { AjaxLoader } from '../../utilities/js/ajax-load-promise.js';
import { WidgetInstance } from 'friendly-challenge';

class Newsletter {
    constructor (element) {
        this.$newsletter = element;
        this.$form = this.$newsletter.querySelector('form');
        this.url = this.$form.getAttribute('action');
        this.$target = this.$newsletter.querySelector('[data-newsletter-target]');
        this.$$formErrors = null;
        this.$submitButton = this.$newsletter.querySelector('[data-form="submit"]');
        this.captcha = null;
    }

    initialize () {
        this.setEvents();
        this.initCaptcha();
    }

    reinit () {
        this.$form = this.$newsletter.querySelector('form');

        if (this.$form) {
            this.url = this.$form.getAttribute('action');
            this.$target = this.$newsletter.querySelector('[data-newsletter-target]');
            this.$$formErrors = this.$newsletter.querySelectorAll('[data-form-error]');
            this.$submitButton = this.$newsletter.querySelector('[data-form="submit"]');
            this.setEvents();
            this.initCaptcha();
        }
    }

    setEvents () {
        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let result;

            if (this.url) {
                result = AjaxLoader.getData(this.url, {
                    method: 'POST',
                    data: new FormData(this.$form)
                });

                this.setResult(result);
            }
        });

        this.$form.addEventListener('keypress', this.stopEnterKey);
    }

    stopEnterKey (event) {
        const target = event.target;

        if (event.key === 'Enter' && target.type === 'text') {
            event.preventDefault();
            return false;
        }
    }

    setResult (result) {
        result.then((results) => {
            const $result = this.createElementFromHTML(results);

            this.$target.firstElementChild.remove();
            this.$target.insertBefore($result, this.$target.firstElementChild);
            this.reinit();

            const $firstError = $result.querySelector('[data-form-error]');

            if ($firstError) {
                $firstError.focus();
            }
        });
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);

            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    initCaptcha () {
        const $friendlyCaptcha = this.$newsletter.querySelector('.frc-captcha');
        const sitekeyContainer = this.$newsletter.querySelector('[data-newsletter-sitekey]');
        const sitekey = sitekeyContainer.getAttribute('data-newsletter-sitekey');

        if (sitekey && $friendlyCaptcha) {
            const options = {
                startMode: 'focus',
                doneCallback: (solution) => {
                    this.captcha = solution;

                    setTimeout(() => {
                        if (this.captcha !== null) {
                            this.$submitButton.classList.remove('disabled');
                            this.$submitButton.removeAttribute('disabled');
                        } else {
                            this.$submitButton.classList.add('disabled');
                            this.$submitButton.setAttribute('disabled', '');
                        }
                    }, 500);
                }
            };
            const widget = new WidgetInstance($friendlyCaptcha, options); // eslint-disable-line
        }
    }
}

export { Newsletter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    const $newsletter = $context.querySelectorAll('[data-newsletter="root"]');

    if ($newsletter.length > 0) {
        for (let i = 0; i < $newsletter.length; i++) {
            const newsletter = new Newsletter($newsletter[i]);
            newsletter.initialize();
        }
    }
});
